import './App.css';
import Topbar from './Components/Topbar';
import Sidebar from './Components/Sidebar';
import Dashboard from './Components/Dashboard';
import { Route, Routes } from 'react-router-dom';
import ProductList from './ProductPages/ProductList';
import ProductGrid from './ProductPages/ProductGrid';
import ProductView from './ProductPages/ProductDetail';
import ProductCreate from './ProductPages/ProductCreate';
import CategoryList from './CategoriesPages/CategoryList';
import ProductEdit from './ProductPages/ProductEdit';
import CategoryEdit from './CategoriesPages/CategoryEdit';
import CategoryCreate from './CategoriesPages/CategoryCreate';
import ReceiveOrder from './Inventory/ReceiveOrder';
import OrderList from './Order/OrderList';
import OrderDetail from './Order/OrderDetail';
import OrderCheckOut from './Order/OrderCheckOut';
import { OrderCart } from "./Order/OrderCart";
import PurchaseList from './Return Management/ReturnList.js';
import PurchaseOrder from './Return Management/PurchaseOrder.js';
import PurchaseReturn from './Return Management/OrderCancle.js';
import AttributeList from './Attribute/AttributeList';
import AttributeEdit from './Attribute/AttributeEdit';
import AttributeAdd from './Attribute/AttributeAdd';
import InvoiceList from './Invoice/InvoiceList';
import InvoiceDetail from './Invoice/InvoiceDetail';
import InvoiceCreate from './Invoice/InvoiceCreate';
import PermissionList from './Permission/PermissionList';
import CustomberList from './Customber/CustomberList';
import CustomerDetail from './Customber/CustomerDetail';
import SellerList from './Seller/SellerList';
import SellerDetail from './Seller/SellerDetail';
import SellerEdit from './Seller/SellerEdit';
import SellerAdd from './Seller/SellerAdd';
import FilterList from './Attribute/FilterList';
import BrandList from './Attribute/BrandList';
import BrandAdd from './Attribute/BrandAdd';
import BrandEdit from './Attribute/BrandEdit';
import ReviewList from './Attribute/ReviewList';
import CouponList from './Components/Coupan';
import { AddNotification, EditNotification, NotificationList, ViewNotification } from './Attribute/NotificationList';
import VendorList from './Vendor/VendorList';
import VendorRegister from './Vendor/CreateVendor';
import SellerDashboard from './Seller/Dashboard/SellerDashboard.js';
import { SellerProduct, SellerProductCreate, SellerProductEdit, SellerProductView } from './Seller/Listings/SellerProduct.js';
import AddSellerProduct from './Seller/Listings/AddSellerProduct.js';
import { AddBankAccountPopup, SellerFinance } from './Seller/Finance/Finance.js';
import SellerShop from './Seller/Shop/Shop.js';
import ReportsPage from './Seller/Report/Report.js';
import SellerSettings from './Seller/Settings/Setting.js';
import SubCategoryList from './Sub-Category/SubCategoryList';
import ColorMaster from './Color/ColorList';
import SizeMaster from './Size/SizeList';
import ProductUnitMaster from './Product Unit/UnitList';
import DiscountMaster from './Discount/Discount';
import DiscountAdd from './Discount/DiscountAdd';
import CountryMaster from './Country/CountryList';
import CountryAdd from './Country/CountryAdd';
import StateList from './State/StateList';
import StateAdd from './State/StateAdd';
import CityMaster from './City/CityList';
import CityAdd from './City/CityAdd';
import BannerMasterList from './Website Management/BannerMasterlist';
import RisingStarList from './Website Management/RisingStarList';
import OfferList from './Website Management/OfferList';
import BrandToBagList from './Website Management/GlobalBrand';
import BannerAdd from './Website Management/BannerAdd';
import BannerEdit from './Website Management/BannerEdit';
import RisingStarAdd from './Website Management/RisingStarAdd';
import RisingStarEdit from './Website Management/RisingStarEdit';
import OfferAdd from './Website Management/OfferAdd';
import OfferEdit from './Website Management/OfferEdit';
import GlobalBrandAdd from './Website Management/GlobalBrandAdd';
import GlobalBrandEdit from './Website Management/GlobalBrandEdit';
import { ToastContainer } from 'react-toastify';
import CategoryView from './CategoriesPages/CategoryView';
import SubCategoryAdd from './Sub-Category/SubCategoryAdd';
import SubCategoryView from './Sub-Category/SubCategoryView';
import SubCategoryEdit from './Sub-Category/SubCategoryEdit.js';
import DiscountEdit from './Discount/DiscountEdit';
import ColorAdd from './Color/ColorAdd';
import ColorEdit from './Color/ColorEdit';
import SizeAdd from './Size/SizeAdd';
import SizeEdit from './Size/SizeEdit';
import UnitAdd from './Product Unit/UnitAdd';
import BrandView from './Attribute/BrandView';
import UnitEdit from './Product Unit/UnitEdit';
import { Warehouse, WarehouseAdd, WarehouseEdit } from './Inventory/Warehouse';
import BannerView from './Website Management/BannerView.js';
import RisingStarView from './Website Management/RisingStarView.js';
import OfferView from './Website Management/OfferView.js';
import GlobalBrandView from './Website Management/GlobalBrandView.js';
import CoupanCreate from './Components/CoupanCreate.js';
import CoupanEdit from './Components/CoupanEdit.js';
import CoupanView from './Components/CoupanView.js';
import CategoryshopList from './Website Management/ShopbycategoryList.js';
import ShopcategoryAdd from './Website Management/ShopbycategoryAdd.js';
import ShopcategoryEdit from './Website Management/ShopbycategoryEdit.js';
import ShopcategoryView from './Website Management/ShopbycategoryView.js';
import TopPickList from './Website Management/Toppick.js';
import CrazyDelaList from './Website Management/CrazyDeals.js';
import Productfu from './Website Management/productsforu.js';
import FashionTopDealsList from './Website Management/FahionTopDeals.js';
import ShopFavoritesList from './Website Management/ShopYourFavorites.js';
import { ContactdetailsPanel, EditContactDetails } from './Contact/Contactdetails.js';
import OrderEdit from './Order/OrderEdit.js';
import { AdevrtisementCreate, AdvertisementEdit, AdvertisementList, AdvertisementView } from './Advertisement/Advertisement.js';
import ContactList from './Contact/ContactUs.js';
import Login from './Login/Login.js';
import SellerRegistration from './Login/sellerregistration.js';
import SellerAdminLogin from './Login/Login.js';
import SellerOrderList from './Manage Sellers/Sellerorderlist.js';
import MarketingCenter from './Seller/Marketing/Marketingcenter.js';
import SellerInvoiceDetail from './Seller/Invoice/sellerinvoice.js';
import Blogs from './Seller/Blogs/Blogs.js';
import SellerRegList from './Manage Sellers/SellerReglist.js';
import SellerView from './Seller/sellerview.js';
import { TractSellerOrder } from './Seller/Listings/TractSellerProd.js';
import SellerLandingPage from './Seller/Seller Landing Page/SellerLandingpage.js';
import { SellerOrder, OrderView } from "./Seller/Order/SellerOrder.js";
import { ContactSeller, ContactView } from './Seller/Contact Seller/ContactSeller.js';
import OrderReturnList from './Return Management/ReturnList.js';
import OrderCancleList from './Return Management/OrderCancle.js';


function App() {
  return (
    <div className='wrapper'>
      <Topbar />
<Sidebar />
<ToastContainer />
<Routes>
          {/*Dashboard Section */}
          <Route exact path="/admin-dashboard" element={<Dashboard />} />
          {/* <Route path="/login" element={<SellerAdminLogin/>} /> */}
          {/* <Route path="/Seller-reg" element={<SellerRegistration />} /> */}

          <Route path="/SellerLandingPage" element={<SellerLandingPage />} />
          <Route path="/sellerReglist" element={<SellerRegList />} />
          <Route path="/seller-view/:id" element={<SellerView />} />

          {/*Product Section */}
          <Route path='/product-list' element={<ProductList />} />
          <Route path='/product-grid' element={<ProductGrid />} />
          <Route path='/product-detail/:id' element={<ProductView />} />
          <Route path='/product-add' element={<ProductCreate />} />
          <Route path='/product-edit/:id' element={<ProductEdit />} />
          
          {/*Category Section */}
          <Route path='/category-list' element={<CategoryList />} />
          <Route path='/category-edit/:id' element={<CategoryEdit />} />
          <Route path='/category-add' element={<CategoryCreate />} />
          <Route path='/category-view/:id' element={<CategoryView />} />
          
          {/*Sub Category Section */}
          <Route path='/sub-category-list' element={<SubCategoryList />} />
          <Route path='/sub-category-add' element={<SubCategoryAdd />} />
          <Route path='/sub-category-view/:id' element={<SubCategoryView />} />
          <Route path='/sub-category-edit/:id' element={<SubCategoryEdit />} />
          
          {/*Colour Section */}
          <Route path='/color-list' element={<ColorMaster />} />
          <Route path='/color-add' element={<ColorAdd />} />
          <Route path='/color-edit/:id' element={<ColorEdit />} />

          {/*Size Section */}
          <Route path='/size-list' element={<SizeMaster />} />
          <Route path='/size-add' element={<SizeAdd />} />
          <Route path='/size-edit/:id' element={<SizeEdit />} />

          {/*Product Unit Section */}
          <Route path='/unit-list' element={<ProductUnitMaster />} />
          <Route path='/unit-add' element={<UnitAdd />} />
          <Route path='/unit-edit/:id' element={<UnitEdit />} />
          
          {/*Discount Section */}
          <Route path='/discount-list' element={<DiscountMaster />} />
          <Route path='/discount-add' element={<DiscountAdd />} />
          <Route path='/discount-edit/:id' element={<DiscountEdit />} />
          
          {/*Location Section */}
          <Route path='/country-list' element={<CountryMaster />} />
          <Route path='/country-add' element={<CountryAdd />} />

          {/*State Section */}
          <Route path='/state-list' element={<StateList />} />
          <Route path='/state-add' element={<StateAdd />} />
          
          {/*City Section */}
          <Route path='/city-list' element={<CityMaster />} />
          <Route path='/city-add' element={<CityAdd />} />

          {/*Inventory Section */}
          <Route path='/inventory-warehouse' element={<Warehouse />} />
          <Route path='/warehouse-add' element={<WarehouseAdd />} />
          <Route path='/warehouse-edit/:id' element={<WarehouseEdit />} />
          <Route path='/inventory-received-orders' element={<ReceiveOrder />} />

          {/*Order Section */}
          <Route path='/order-list' element={<OrderList />} />
          <Route path='/order-list-edit/:id' element={<OrderEdit />} />
          <Route path='/order-detail-view/:id' element={<OrderDetail />} />
          <Route path='/order-cart' element={<OrderCart />} />
          <Route path='/order-checkout' element={<OrderCheckOut />} />

          {/*Purchase Section */}
          <Route path='/return-list' element={<OrderReturnList />} />
          <Route path='/purchase-order' element={<PurchaseOrder />} />
          <Route path='/cancle-list' element={<OrderCancleList />} />

          {/*Attribute Section */}
          <Route path='/attribute-list' element={<AttributeList />} />
          <Route path='/attribute-edit/:id' element={<AttributeEdit />} />
          <Route path='/attribute-add' element={<AttributeAdd />} />

          
          <Route path='/filter-list' element={<FilterList />} />
          <Route path='/brand-list' element={<BrandList />} />
          <Route path='/brand-add' element={<BrandAdd />} />
          <Route path='/brand-edit/:id' element={<BrandEdit />} />
          <Route path='/brand-view/:id' element={<BrandView />} />
          <Route path='/review-list' element={<ReviewList />} />

          {/*Invoice Section */}
          <Route path='/invoice-list' element={<InvoiceList />} />
          <Route path='/invoice-detail/:order_id' element={<InvoiceDetail />} />
          <Route path='/invoice-add' element={<InvoiceCreate />} />

          {/*Permission Section */}
          <Route path='/permission' element={<PermissionList />} />

          {/*Customer Section */}
          <Route path='/customer-list' element={<CustomberList />} />
          <Route path='/customer-detail' element={<CustomerDetail />} />

          {/*Seller Section */}
          <Route path='/seller-list' element={<SellerList />} />
          <Route path='/seller-detail' element={<SellerDetail />} />
          <Route path='/seller-edit' element={<SellerEdit />} />
          <Route path='/seller-add' element={<SellerAdd />} />

          {/*Seller Product Section */}
          <Route path="/sellerorderlist" element={<SellerOrderList />} />
          <Route path="/sellerorderlist-view/:id" element={<SellerProductView/>} />
          

          {/*Vendor Section */}
          <Route path='/vendor-list' element={<VendorList />} />
          <Route path='/vendor-register' element={<VendorRegister />} />

          {/*Other Section */}
          <Route path='/coupon-list' element={<CouponList />} />
          <Route path='/coupon-list-add' element={<CoupanCreate />} />
          <Route path='/coupon-list-edit/:id' element={<CoupanEdit />} />
          <Route path='/coupon-list-view' element={<CoupanView />} />
          
          <Route path='/notification-list' element={<NotificationList />} />
          <Route path='/notification-list-add' element={<AddNotification />} />
          <Route path='/notification-list-edit/:id' element={<EditNotification />} />
          <Route path='/notification-list-view/:id' element={<ViewNotification />} />



          {/* seller  */}
          <Route path='/seller-dashboard' element={<SellerDashboard />} />
          <Route path='/seller-order' element={<SellerOrder />} />
          <Route path='/seller-order-view/:id' element={<OrderView />} />

          {/* seller Product Section */}
          <Route path='/sellerproduct' element={<SellerProduct />} />
          <Route path='/sellerproduct-add' element={<SellerProductCreate />} />
          <Route path='/sellerproduct-edit/:id' element={<SellerProductEdit />} />
          <Route path='/sellerproduct-view/:id' element={<SellerProductView />} />


          <Route path='/add-seller-product' element={<AddSellerProduct />} />
          <Route path='/seller-finance' element={<SellerFinance />} />
          <Route path='/seller-finance-add' element={<AddBankAccountPopup />} />
          <Route path='/seller-shop' element={<SellerShop />} />
          <Route path='/report' element={<ReportsPage />} />
          <Route path='/setting' element={<SellerSettings />} />

          <Route path='/Tract-Seller-Order' element={<TractSellerOrder />} />

          {/* website manager  */}
          <Route path='/Banner' element={<BannerMasterList />} />
          <Route path='/Banner-add' element={<BannerAdd />} />
          <Route path='/Banner-edit/:id' element={<BannerEdit />} />
          <Route path='/Banner-view/:id' element={<BannerView />} />

          {/*RisingStar Section */}
          <Route path='/Rising' element={<RisingStarList />} />
          <Route path='/Rising-add' element={<RisingStarAdd />} />
          <Route path='/Rising-edit/:id' element={<RisingStarEdit />} />
          <Route path='/Rising-view/:id' element={<RisingStarView />} />

          {/*Offer Section */}
          <Route path='/Offer' element={<OfferList />} />
          <Route path='/Offer-add' element={<OfferAdd />} />
          <Route path='/Offer-edit/:id' element={<OfferEdit />} />
          <Route path='/Offer-view/:id' element={<OfferView />} />

          {/*Brand to Bag Section */}
          <Route path='/GlobalBrand' element={<BrandToBagList />} />
          <Route path='/GlobalBrand-add' element={<GlobalBrandAdd />} />
          <Route path='/GlobalBrand-edit/:id' element={<GlobalBrandEdit />} />
          <Route path='/GlobalBrand-view/:id' element={<GlobalBrandView />} />

          {/*Shop By Category Section */}
          <Route path='/ShopByCategory' element={<CategoryshopList />} />
          <Route path='/ShopByCategory-add' element={<ShopcategoryAdd />} />
          <Route path='/ShopByCategory-edit/:id' element={<ShopcategoryEdit />} />
          <Route path='/ShopByCategory-view/:id' element={<ShopcategoryView />} />

          {/*Fashion Top Deals Section */}
          <Route path='/Fashiontopdeals' element={<FashionTopDealsList />} />

          {/*Fashion Top Deals Section */}
          <Route path='/ShopFavorites' element={<ShopFavoritesList />} />

          {/*Top Pick Section */}
          <Route path='/TopPick' element={<TopPickList />} />

          {/*Crazy Deals Section */}
          <Route path='/CrazyDeals' element={<CrazyDelaList />} />

          {/*Products for you Section */}
          <Route path='/Productfu' element={<Productfu />} />

          {/*Contact Section */}
          <Route path='/contact-detail' element={<ContactdetailsPanel />} />
          <Route path='/contact-detail/:id' element={<EditContactDetails />} />

          <Route path='/contactUS' element={<ContactList />} />

          {/*Advertisement Section */}
          <Route path='/Advertisement' element={<AdvertisementList />} />
          <Route path='/Advertisement-add' element={<AdevrtisementCreate />} />
          <Route path='/Advertisement-edit/:id' element={<AdvertisementEdit />} />
          <Route path='/Advertisement-view/:id' element={<AdvertisementView />} />

          {/* Marketing center section*/}
          <Route path="/Marketingcenter" element={<MarketingCenter />} />

          {/* Seller Invoice section*/}
          <Route path="/Seller-invoice" element={<SellerInvoiceDetail />} />

          {/* Seller Blogs section*/}
          <Route path="/Seller-blog" element={<Blogs />} />

          {/* Seller Contact section*/}
          <Route path="/seller-contact" element={< ContactSeller />} />
          <Route path="/seller-contact-view/:id" element={< ContactView />} />
        </Routes>
    </div>
  );
}

export default App;
